/* ============================================================================
   LAH — QUIZ DE INDICACAO DE LENTES MULTIFOCAIS (GRAU E SOLAR)
   Tema: Outubro (Claude 14.0)

   Tres perguntas de cotidiano recomendam as lentes — e APLICAM as escolhas
   no proprio fluxo, clicando nas opcoes, uma etapa por vez.

   DOIS QUIZZES, UM MOTOR:

     GRAU ... etapa "Escolha o campo de visao" dos oculos de grau.
              Recomenda campo de visao, espessura multifocal e tratamento.

     SOLAR .. etapa "Escolha o campo de visao do seu solar", caminho
              "Solar Multifocal" dos oculos de sol. Recomenda campo de visao
              e espessura solar; a TONALIDADE e ESCOLHA DO CLIENTE.

   ============================================================================
   TONALIDADE: ESCOLHA, NAO SUGESTAO (quiz solar)
   ============================================================================
   Cor de lente e gosto pessoal — indicar uma tonalidade a partir do uso
   parecia decidir pelo cliente algo que ele sabe melhor que nos. No
   resultado, a tonalidade aparece como ESCOLHA DIRETA: uma amostra de cor por
   opcao, com uma frase sobre o efeito e o preco.

     - Nada vem pre-marcado.
     - "Aplicar essa combinacao" (e a alternativa economica) so ficam ativos
       depois da escolha.
     - O total das lentes se atualiza com o preco da tonalidade escolhida.
     - Ao aplicar, o pedido e montado inteiro: campo, espessura e tonalidade.

   AS OPCOES VEM DA PROPRIA ETAPA DE TONALIDADE do configurador, nao de uma
   lista fixa aqui. Se uma tonalidade nova (o Cinza, por exemplo) for
   acrescentada no admin, ela aparece no quiz sozinha, com o preco certo.
   Frases e cores das amostras ficam em TONALIDADES, abaixo; uma tonalidade
   sem entrada ali aparece com amostra neutra e sem frase.

   A primeira pergunta (onde vai usar) continua valendo para o CAMPO DE
   VISAO: dirigindo + "o tempo todo" leva ao Dinamico; esportes, ao Amplo.

   ============================================================================
   O DEFEITO QUE TRAVAVA O MULTIFOCAL SOLAR (corrigido)
   ============================================================================
   O quiz de grau procurava a etapa cujo identificador CONTEM "campo-de-visao"
   — e a etapa solar tambem contem. Agora cada quiz reconhece SO a sua etapa.

   ============================================================================
   REGRAS
   ============================================================================
   Clica nas opcoes em vez de escrever o estado do Alpine: preco, etapas e
   resumo sao calculados pelo proprio configurador. Precos sao LIDOS dos
   cartoes, nunca escritos aqui.

   ESPESSURA e restricao do grau: sem grau informado, o quiz aplica o campo
   de visao e PARA na etapa de espessura. CAMPO DE VISAO parte do mais barato;
   o Dinamico exige dois sinais simultaneos. A alternativa economica aparece
   como botao discreto, com o preco dela.

   EVENTOS (GTM): grau -> lens_quiz_*; solar -> lens_quiz_solar_*
   (aberto, resultado, tonalidade, aplicado).
   ============================================================================ */

(function () {
    'use strict';

    var root = document.querySelector('.product-lens-select');
    if (!root) return;

    /* Amostras e frases das tonalidades solares, pelo nome da opcao
       (sem acento, minusculo). */
    var TONALIDADES = {
        'verde g15': { cor: 'radial-gradient(circle at 35% 30%, #6F7F62 0%, #3B4A35 55%, #26301F 100%)', frase: 'Cores naturais e mais contraste' },
        'marrom': { cor: 'radial-gradient(circle at 35% 30%, #9A7454 0%, #6B4A2E 55%, #47301C 100%)', frase: 'Relaxa a visão e reduz o cansaço' },
        'cinza': { cor: 'radial-gradient(circle at 35% 30%, #8A8C8E 0%, #55585B 55%, #36383A 100%)', frase: 'Escurece sem alterar as cores' }
    };

    var estilo = document.createElement('style');
    estilo.textContent =
        '.lah-quiz__ton{margin:14px 0 6px;}' +
        '.lah-quiz__ton-titulo{margin:0 0 8px;font-size:13px;font-weight:600;}' +
        '.lah-quiz__ton-opcoes{display:grid;grid-template-columns:repeat(auto-fit,minmax(140px,1fr));gap:8px;}' +
        '.lah-quiz__ton-opt{display:flex;align-items:center;gap:10px;padding:10px 12px;text-align:left;' +
        'border:1px solid #DADAD8;border-radius:12px;background:#FFFFFF;color:inherit;font:inherit;cursor:pointer;' +
        'transition:border-color .15s ease,box-shadow .15s ease;}' +
        '.lah-quiz__ton-opt:hover{border-color:#B9BDB9;}' +
        '.lah-quiz__ton-opt.is-on{border-color:#112A1F;box-shadow:0 0 0 1px #112A1F;}' +
        '.lah-quiz__ton-cor{flex-shrink:0;width:28px;height:28px;border-radius:50%;' +
        'box-shadow:inset 0 0 0 1px rgba(0,0,0,.12);background:#8A8C8E;}' +
        '.lah-quiz__ton-txt{display:flex;flex-direction:column;gap:1px;min-width:0;}' +
        '.lah-quiz__ton-nome{font-size:13px;font-weight:600;line-height:1.25;}' +
        '.lah-quiz__ton-frase{font-size:11.5px;line-height:1.3;opacity:.72;}' +
        '.lah-quiz__ton-preco{font-size:11.5px;opacity:.72;}' +
        '.lah-quiz__ton-aviso{margin:8px 0 0;font-size:12px;opacity:.7;}' +
        '.lah-quiz__apply[disabled],.lah-quiz__alt[disabled]{opacity:.45;cursor:not-allowed;}';
    document.head.appendChild(estilo);

    function normalize(text) {
        return (text || '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .trim();
    }

    function track(eventName, payload) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
        } catch (e) { /* analytics nunca deve quebrar a venda */ }
    }

    function moeda(centavos) {
        return (centavos / 100).toLocaleString('pt-BR', {
            style: 'currency', currency: 'BRL'
        });
    }

    function esc(str) {
        var d = document.createElement('div');
        d.textContent = str == null ? '' : String(str);
        return d.innerHTML;
    }

    function acharEtapa(fragmento, evitar) {
        var steps = root.querySelectorAll('.product-lens-select-step');
        for (var i = 0; i < steps.length; i++) {
            var s = steps[i].getAttribute('data-step-selector') || '';
            if (s.indexOf(fragmento) === -1) continue;
            if (evitar && s.indexOf(evitar) !== -1) continue;
            return steps[i];
        }
        return null;
    }

    function acharOpcao(etapa, nomeAlvo) {
        if (!etapa || !nomeAlvo) return null;
        var itens = etapa.querySelectorAll('.product-lens-select-item');
        var alvo = normalize(nomeAlvo);

        for (var i = 0; i < itens.length; i++) {
            if (normalize(itens[i].getAttribute('data-item-name')) === alvo) {
                return itens[i];
            }
        }
        return null;
    }

    function precoDaOpcao(item) {
        if (!item) return 0;
        var input = item.querySelector('input[name="item-variant-price"]');
        return input ? parseInt(input.value, 10) || 0 : 0;
    }

    /* =====================================================================
       CONFIGURACAO DOS DOIS QUIZZES
       ===================================================================== */
    var QUIZZES = [
        {
            id: 'grau',
            evento: 'lens_quiz',
            titulo: 'Descubra suas lentes rapidamente',
            sub: 'Responda 3 perguntas rápidas e indicamos a combinação certa',
            escolhaTerceira: false,
            etapas: [
                { rotulo: 'Campo de visão', fragmento: 'campo-de-visao', evitar: 'solar' },
                { rotulo: 'Espessura', fragmento: 'espessura-de-suas-lentes-multifocais', evitar: 'solar' },
                { rotulo: 'Tratamento', fragmento: 'tratamento', evitar: 'solar' }
            ],
            economico: 'Base',
            perguntas: [
                {
                    nome: 'usos', multiplo: true,
                    pergunta: 'No dia a dia, onde você mais usa os óculos?',
                    dica: 'Pode marcar mais de um.',
                    opcoes: [
                        { valor: 'telas', rotulo: 'Computador e celular' },
                        { valor: 'perto', rotulo: 'Leitura e trabalho de perto' },
                        { valor: 'dirige', rotulo: 'Dirigindo' },
                        { valor: 'ar_livre', rotulo: 'Atividades ao ar livre' }
                    ]
                },
                {
                    nome: 'alterna',
                    pergunta: 'Você alterna muito entre olhar de perto e de longe?',
                    opcoes: [
                        { valor: 'muito', rotulo: 'O tempo todo' },
                        { valor: 'as_vezes', rotulo: 'Às vezes' },
                        { valor: 'pouco', rotulo: 'Pouco' }
                    ]
                },
                {
                    nome: 'grau',
                    pergunta: 'Você já sabe o seu grau?',
                    dica: 'Está na sua receita. Se não souber, tudo bem.',
                    opcoes: [
                        { valor: 'ate275', rotulo: 'Até 2,75' },
                        { valor: 'ate475', rotulo: 'Entre 3 e 4,75' },
                        { valor: 'acima5', rotulo: 'Acima de 5' },
                        { valor: 'naosei', rotulo: 'Não sei ainda' }
                    ]
                }
            ],
            recomendar: function (r) {
                var usos = r.usos;
                var telas = usos.indexOf('telas') !== -1;
                var dirige = usos.indexOf('dirige') !== -1;
                var arLivre = usos.indexOf('ar_livre') !== -1;

                var out = {
                    campo: 'Base',
                    porque_campo: 'Seu uso é mais estável, então o Base já entrega nitidez e conforto.',
                    espessura: null, porque_espessura: '',
                    terceira: 'Clássico',
                    porque_terceira: 'Antirreflexo, proteção UV e anti-risco já vêm inclusos.'
                };

                if (r.alterna === 'muito' && dirige) {
                    out.campo = 'Dinâmico';
                    out.porque_campo = 'Como você alterna muito entre distâncias e dirige com frequência, a transição suave e a menor distorção nas laterais fazem diferença real.';
                } else if (r.alterna === 'as_vezes' || r.alterna === 'muito' || telas) {
                    out.campo = 'Amplo';
                    out.porque_campo = 'Você alterna entre perto e longe com frequência, e o campo maior facilita a adaptação.';
                }

                if (r.grau === 'ate275') {
                    out.espessura = 'Multifocal Normal';
                    out.porque_espessura = 'Seu grau está dentro da faixa da lente padrão.';
                } else if (r.grau === 'ate475') {
                    out.espessura = 'Multifocal Fina';
                    out.porque_espessura = 'A partir desse grau a lente fina evita peso e espessura na borda.';
                } else if (r.grau === 'acima5') {
                    out.espessura = 'Multifocal Super Fina';
                    out.porque_espessura = 'Grau mais alto pede a lente mais fina para o óculos não ficar pesado.';
                }

                if (telas && arLivre) {
                    out.terceira = 'Filtro de luz azul + Fotossensível';
                    out.porque_terceira = 'Você usa telas e passa tempo ao ar livre — os dois tratamentos se complementam.';
                } else if (telas) {
                    out.terceira = 'Filtro de luz azul';
                    out.porque_terceira = 'Você passa bastante tempo em telas.';
                } else if (arLivre) {
                    out.terceira = 'Fotossensível';
                    out.porque_terceira = 'A lente escurece sozinha na luz do sol.';
                }

                return out;
            }
        },
        {
            id: 'solar',
            evento: 'lens_quiz_solar',
            titulo: 'Descubra suas lentes solares rapidamente',
            sub: 'Responda 3 perguntas rápidas e indicamos a combinação certa para o seu solar',
            escolhaTerceira: true,
            etapas: [
                { rotulo: 'Campo de visão', fragmento: 'campo-de-visao-do-seu-solar' },
                { rotulo: 'Espessura', fragmento: 'espessura-de-suas-lentes-solares' },
                { rotulo: 'Tonalidade', fragmento: 'tonalidade-de-suas-lentes' }
            ],
            economico: 'Solar Base',
            perguntas: [
                {
                    nome: 'usos', multiplo: true,
                    pergunta: 'Onde você mais vai usar o seu solar multifocal?',
                    dica: 'Pode marcar mais de um.',
                    opcoes: [
                        { valor: 'dirige', rotulo: 'Dirigindo' },
                        { valor: 'praia', rotulo: 'Praia, piscina e ar livre' },
                        { valor: 'esporte', rotulo: 'Caminhadas e esportes' },
                        { valor: 'cidade', rotulo: 'Passeios na cidade' }
                    ]
                },
                {
                    nome: 'alterna',
                    pergunta: 'Com o solar no rosto, você alterna muito entre perto e longe?',
                    dica: 'Como olhar o celular ou o painel do carro e depois a paisagem.',
                    opcoes: [
                        { valor: 'muito', rotulo: 'O tempo todo' },
                        { valor: 'as_vezes', rotulo: 'Às vezes' },
                        { valor: 'pouco', rotulo: 'Pouco' }
                    ]
                },
                {
                    nome: 'grau',
                    pergunta: 'Você já sabe o seu grau?',
                    dica: 'Está na sua receita. Se não souber, tudo bem.',
                    opcoes: [
                        { valor: 'ate4', rotulo: 'Até 4,00' },
                        { valor: 'ate6', rotulo: 'Entre 4,25 e 6,00' },
                        { valor: 'acima6', rotulo: 'Acima de 6,00' },
                        { valor: 'naosei', rotulo: 'Não sei ainda' }
                    ]
                }
            ],
            recomendar: function (r) {
                var usos = r.usos;
                var dirige = usos.indexOf('dirige') !== -1;
                var esporte = usos.indexOf('esporte') !== -1;

                var out = {
                    campo: 'Solar Base',
                    porque_campo: 'Seu uso com o solar é mais estável, então o Base já entrega nitidez e conforto.',
                    espessura: null, porque_espessura: '',
                    terceira: null, porque_terceira: ''
                };

                if (r.alterna === 'muito' && dirige) {
                    out.campo = 'Solar Dinâmico';
                    out.porque_campo = 'Ao dirigir você alterna o tempo todo entre painel, retrovisor e estrada — a transição suave e a menor distorção nas laterais fazem diferença real.';
                } else if (r.alterna === 'as_vezes' || r.alterna === 'muito' || esporte) {
                    out.campo = 'Solar Amplo';
                    out.porque_campo = 'Você alterna entre perto e longe ou está em movimento, e o campo maior facilita a adaptação.';
                }

                if (r.grau === 'ate4') {
                    out.espessura = 'Solar Normal';
                    out.porque_espessura = 'Seu grau está dentro da faixa da lente solar padrão.';
                } else if (r.grau === 'ate6') {
                    out.espessura = 'Solar Fina';
                    out.porque_espessura = 'A partir desse grau a lente fina evita peso e espessura na borda.';
                } else if (r.grau === 'acima6') {
                    out.espessura = 'Solar Super Fina';
                    out.porque_espessura = 'Grau mais alto pede a lente mais fina para o solar não ficar pesado.';
                }

                return out;
            }
        }
    ];

    /* =====================================================================
       MOTOR — um quiz por configuracao
       ===================================================================== */
    function montarQuiz(cfg) {
        var respostas = { usos: [], terceiraEscolhida: null };
        var E = cfg.etapas;

        function etapa(i) { return acharEtapa(E[i].fragmento, E[i].evitar); }

        function linha(rotulo, valor, preco, porque) {
            return '<div class="lah-quiz__row"><div>' +
                '<span class="lah-quiz__row-label">' + rotulo + '</span>' +
                '<p class="lah-quiz__why">' + porque + '</p></div>' +
                '<span class="lah-quiz__row-value">' + valor + '<br>' +
                (preco > 0 ? moeda(preco) : 'incluso') + '</span></div>';
        }

        /* Escolha da tonalidade — opcoes lidas da propria etapa. */
        function blocoEscolha() {
            var et = etapa(2);
            var itens = et ? et.querySelectorAll('.product-lens-select-item') : [];
            if (!itens.length) return '';

            var html = '<div class="lah-quiz__ton">' +
                '<p class="lah-quiz__ton-titulo">' + E[2].rotulo + ' — escolha a sua</p>' +
                '<div class="lah-quiz__ton-opcoes">';

            Array.prototype.forEach.call(itens, function (item) {
                var nome = item.getAttribute('data-item-name') || '';
                var info = TONALIDADES[normalize(nome)] || {};
                var preco = precoDaOpcao(item);
                var ativo = respostas.terceiraEscolhida && normalize(respostas.terceiraEscolhida) === normalize(nome);

                html += '<button type="button" class="lah-quiz__ton-opt' + (ativo ? ' is-on' : '') + '" data-quiz-ton="' + esc(nome) + '" aria-pressed="' + (ativo ? 'true' : 'false') + '">' +
                    '<span class="lah-quiz__ton-cor"' + (info.cor ? ' style="background:' + info.cor + '"' : '') + '></span>' +
                    '<span class="lah-quiz__ton-txt">' +
                    '<span class="lah-quiz__ton-nome">' + esc(nome) + '</span>' +
                    (info.frase ? '<span class="lah-quiz__ton-frase">' + esc(info.frase) + '</span>' : '') +
                    '<span class="lah-quiz__ton-preco">' + (preco > 0 ? moeda(preco) : 'incluso') + '</span>' +
                    '</span></button>';
            });

            html += '</div>';
            if (!respostas.terceiraEscolhida) {
                html += '<p class="lah-quiz__ton-aviso">Escolha a tonalidade para aplicar a combinação.</p>';
            }
            return html + '</div>';
        }

        function montarResultado(painel) {
            var r = cfg.recomendar(respostas);
            var terceiraNome = cfg.escolhaTerceira ? respostas.terceiraEscolhida : r.terceira;
            var pronto = !cfg.escolhaTerceira || !!terceiraNome;

            var optCampo = acharOpcao(etapa(0), r.campo);
            var optEsp = r.espessura ? acharOpcao(etapa(1), r.espessura) : null;
            var optTer = terceiraNome ? acharOpcao(etapa(2), terceiraNome) : null;

            var total = precoDaOpcao(optCampo) + precoDaOpcao(optEsp) + precoDaOpcao(optTer);
            var aPartir = !r.espessura || !pronto;

            var html = '<p class="lah-quiz__result-title">Nossa indicação para você</p>';

            html += linha(E[0].rotulo, r.campo, precoDaOpcao(optCampo), r.porque_campo);

            if (r.espessura) {
                html += linha(E[1].rotulo, r.espessura, precoDaOpcao(optEsp), r.porque_espessura);
            } else {
                html += '<div class="lah-quiz__row"><div>' +
                    '<span class="lah-quiz__row-label">' + E[1].rotulo + '</span>' +
                    '<p class="lah-quiz__why">Depende do seu grau, e sem ele não dá para indicar com segurança. ' +
                    'Escolha na próxima etapa ou fale com a gente no WhatsApp.</p></div>' +
                    '<span class="lah-quiz__row-value">a definir</span></div>';
            }

            if (cfg.escolhaTerceira) {
                html += blocoEscolha();
            } else {
                html += linha(E[2].rotulo, r.terceira, precoDaOpcao(optTer), r.porque_terceira);
            }

            html += '<div class="lah-quiz__total"><span>Lentes</span><strong>' +
                (aPartir ? 'a partir de ' : '') + moeda(total) +
                '</strong></div>';

            html += '<button type="button" class="lah-quiz__apply" data-quiz-aplicar' + (pronto ? '' : ' disabled') + '>' +
                'Aplicar essa combinação</button>';

            var temAlternativa = false;

            if (r.campo !== cfg.economico) {
                var optBase = acharOpcao(etapa(0), cfg.economico);

                if (optBase) {
                    var totalBase = precoDaOpcao(optBase) + precoDaOpcao(optEsp) + precoDaOpcao(optTer);

                    html += '<button type="button" class="lah-quiz__alt" data-quiz-economica' + (pronto ? '' : ' disabled') + '>' +
                        'Prefiro a opção mais econômica · ' +
                        (aPartir ? 'a partir de ' : '') + moeda(totalBase) +
                        '</button>';

                    temAlternativa = true;
                }
            }

            html += '<p class="lah-quiz__foot">Você pode trocar qualquer opção depois.</p>';

            painel.innerHTML = html;
            painel.classList.add('is-on');

            var rFinal = Object.assign({}, r, { terceira: terceiraNome });

            painel.querySelector('[data-quiz-aplicar]').addEventListener('click', function () {
                if (!pronto) return;
                aplicar(rFinal, false);
            });

            if (temAlternativa) {
                painel.querySelector('[data-quiz-economica]').addEventListener('click', function () {
                    if (!pronto) return;
                    aplicar(Object.assign({}, rFinal, { campo: cfg.economico }), true);
                });
            }

            /* Escolha da tonalidade: um ouvinte so por painel, que sobrevive
               as reconstrucoes do conteudo. */
            if (cfg.escolhaTerceira && !painel._lahTon) {
                painel._lahTon = true;
                painel.addEventListener('click', function (event) {
                    var bt = event.target.closest('[data-quiz-ton]');
                    if (!bt) return;
                    respostas.terceiraEscolhida = bt.getAttribute('data-quiz-ton');
                    track(cfg.evento + '_tonalidade', { tonalidade: respostas.terceiraEscolhida });
                    montarResultado(painel);
                });
            }

            track(cfg.evento + '_resultado', {
                campo: r.campo,
                espessura: r.espessura || 'indefinida',
                complemento: terceiraNome || 'a escolher',
                valor_lentes: total / 100
            });
        }

        /* Clica nas opcoes, uma etapa por vez, esperando a seguinte aparecer.
           Tentativas limitadas: se o catalogo mudou, para em silencio e o
           cliente segue com a mao — nunca trava. */
        function clicarQuando(i, nomeOpcao, aoTerminar) {
            var tentativas = 0;

            (function tentar() {
                var et = etapa(i);
                var opcao = et ? acharOpcao(et, nomeOpcao) : null;
                var visivel = et && et.offsetParent !== null;

                if (opcao && visivel) {
                    opcao.click();
                    requestAnimationFrame(function () {
                        setTimeout(function () { if (aoTerminar) aoTerminar(); }, 90);
                    });
                    return;
                }

                tentativas++;
                if (tentativas > 40) return;
                setTimeout(tentar, 60);
            })();
        }

        function aplicar(r, economica) {
            track(cfg.evento + '_aplicado', {
                campo: r.campo,
                espessura: r.espessura || 'indefinida',
                complemento: r.terceira,
                economica: !!economica
            });

            clicarQuando(0, r.campo, function () {
                if (!r.espessura) return; /* para aqui: o cliente escolhe a espessura */
                clicarQuando(1, r.espessura, function () {
                    if (r.terceira) clicarQuando(2, r.terceira, null);
                });
            });
        }

        function grupo(p) {
            var html = '<p class="lah-quiz__q">' + p.pergunta + '</p>';
            if (p.dica) html += '<p class="lah-quiz__hint">' + p.dica + '</p>';
            html += '<div class="lah-quiz__opts" data-quiz-grupo="' + p.nome + '"' +
                (p.multiplo ? ' data-quiz-multiplo="1"' : '') + '>';
            p.opcoes.forEach(function (o) {
                html += '<button type="button" class="lah-quiz__opt" data-quiz-valor="' +
                    o.valor + '">' + o.rotulo + '</button>';
            });
            return html + '</div>';
        }

        function criar(et) {
            if (et.querySelector('.lah-quiz')) return true;

            var box = document.createElement('div');
            box.className = 'lah-quiz lah-quiz--' + cfg.id;

            box.innerHTML =
                '<button type="button" class="lah-quiz__toggle" data-quiz-toggle>' +
                '<span class="lah-quiz__toggle-icon">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
                '<circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 1 1 3.2 2.4c-.5.2-.7.6-.7 1.1v.5"/><path d="M12 17v.3"/>' +
                '</svg></span>' +
                '<span><span class="lah-quiz__toggle-title">' + cfg.titulo + '</span>' +
                '<span class="lah-quiz__toggle-sub">' + cfg.sub + '</span></span>' +
                '<span class="lah-quiz__chev">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
                '<path d="M6 9l6 6 6-6"/></svg></span>' +
                '</button>' +
                '<div class="lah-quiz__body">' +
                cfg.perguntas.map(grupo).join('') +
                '<div class="lah-quiz__result" data-quiz-result></div>' +
                '</div>';

            var titulo = et.querySelector('.product-lens-step-title');

            if (titulo && titulo.parentNode === et) {
                et.insertBefore(box, titulo.nextSibling);
            } else if (titulo && titulo.parentNode && titulo.parentNode.parentNode === et) {
                et.insertBefore(box, titulo.parentNode.nextSibling);
            } else {
                et.insertBefore(box, et.firstChild);
            }

            box.querySelector('[data-quiz-toggle]').addEventListener('click', function () {
                var abrindo = !box.classList.contains('is-open');
                box.classList.toggle('is-open', abrindo);
                if (abrindo) track(cfg.evento + '_aberto', {});
            });

            box.addEventListener('click', function (event) {
                var opt = event.target.closest('.lah-quiz__opt');
                if (!opt) return;

                var grupoEl = opt.parentElement;
                var nome = grupoEl.getAttribute('data-quiz-grupo');
                var valor = opt.getAttribute('data-quiz-valor');

                if (grupoEl.hasAttribute('data-quiz-multiplo')) {
                    opt.classList.toggle('is-on');
                    var idx = respostas.usos.indexOf(valor);
                    if (idx === -1) respostas.usos.push(valor);
                    else respostas.usos.splice(idx, 1);
                } else {
                    Array.prototype.forEach.call(
                        grupoEl.querySelectorAll('.lah-quiz__opt'),
                        function (b) { b.classList.toggle('is-on', b === opt); }
                    );
                    respostas[nome] = valor;
                }

                if (respostas.alterna && respostas.grau) {
                    montarResultado(box.querySelector('[data-quiz-result]'));
                }
            });

            return true;
        }

        return { criar: criar, etapaQuiz: function () { return etapa(0); } };
    }

    var quizzes = QUIZZES.map(montarQuiz);
    var observer = null;

    function aplicarQuizzes() {
        var pendentes = 0;

        quizzes.forEach(function (q) {
            var et = q.etapaQuiz();
            if (et && !et.querySelector('.lah-quiz')) q.criar(et);
        });

        quizzes.forEach(function (q) {
            var et = q.etapaQuiz();
            if (et && !et.querySelector('.lah-quiz')) pendentes++;
        });

        if (root.querySelector('.lah-quiz') && pendentes === 0 && observer) {
            observer.disconnect();
            observer = null;
        }
    }

    aplicarQuizzes();

    if (!root.querySelector('.lah-quiz') && window.MutationObserver) {
        var pendente = false;

        observer = new MutationObserver(function () {
            if (pendente) return;
            pendente = true;
            requestAnimationFrame(function () {
                pendente = false;
                aplicarQuizzes();
            });
        });

        observer.observe(root, { childList: true, subtree: true });
    }
})();
